var _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
function SvgChevronRightNoColor(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 10,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M6.133 8L0 1.867 1.867 0l8 8-8 8L0 14.133 6.133 8z",
    fill: "currentColor"
  })));
}
export default SvgChevronRightNoColor;